 <template>
  <div>
    <div>
      <b-switch class="is-pulled-right" v-model="onlyVip">VIP Only</b-switch>
    </div>
    <b-table :data="rows" :paginated="true" :per-page="20">
      <template slot-scope="props">
        <b-table-column field="image" label="Image"><img :src="props.row.image || 'https://static.thenounproject.com/png/1554490-200.png'"  style="max-width:100px; max-height: 80px;"/></b-table-column>
        <b-table-column width="30" field="coupon" label="Coupon code" sortable>{{props.row.discountMethod}}</b-table-column>
        <b-table-column field="link" label="Product link" sortable>
          <a :href="props.row.link" target="_blank">{{ truncate(props.row.title || props.row.link, 36) }}</a>
        </b-table-column>
        <b-table-column
          field="originalPrice"
          label="Original price"
          sortable
        >{{ props.row.originalPrice }}</b-table-column>
        <b-table-column field="newPrice" label="Discounted price" sortable>{{ props.row.newPrice }}</b-table-column>
        <!-- <b-table-column
          field="dateFrom"
          label="Starts on"
          sortable
        >{{ new Date(props.row.dateFrom.seconds*1000).toLocaleDateString() }}</b-table-column> -->
        <b-table-column
          field="dateTo"
          label="Expires on"
          sortable
        >{{ new Date(props.row.dateTo.seconds*1000).toLocaleDateString() }}</b-table-column>
        <b-table-column field="email" label="Sent by" sortable>{{ props.row.email }}</b-table-column>
        <b-table-column field="status" label="Reject" sortable>
          <b-select
            placeholder="Reject reason"
            @input="(value) => rejectDeal(props.row, value)"
            v-model="props.row.status"
          >
            <option v-for="option in options" :value="option.id" :key="option.id">{{ option.value }}</option>
          </b-select>
        </b-table-column>
        <b-table-column>
          <b-button type="is-info" @click="() => copyToPostbot(props.row)">PostBot</b-button>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

const options = [
  { id: "NOT_WORKING", value: "Code not working" },
  { id: "BAD_REVIEWS", value: "Bad reviews" },
  { id: "TOO_LOW_DISCOUNT", value: "Too low discount" },
  { id: "OFF_TOPIC", value: "Off-topic" },
  { id: "DUPLICATE", value: "Duplicate" },
  { id: "NOT_FBA", value: "Not FBA item" },
  { id: "CHEAT_PRICE", value: "Cheated with initial price" },
  { id: "COUPON_EXPIRED", value: "Coupon is expired" },
  { id: "OTHER_REASON", value: "Other reason" }
];

export default {
  name: "AdminDeals",
  data() {
    return {
      rows: [],
      allRows: [],
      vips: [],
      options,
      onlyVip: false
    };
  },
  created() {
    const db = firebase.firestore();
    db.collection("deals")
      .where("status", "==", "pending")
      .get()
      .then(querySnapshot => {
        const rows = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (!data.status || data.status === "pending")
            data.status = undefined;
          data.id = doc.id;
          data.discountMethod = `${data.coupon ? `${data.coupon}` : ''} ${data.checkout ? `+ ${data.checkout}${data.unitCheckout}` : ''}`
          rows.push(data);
        });
        this.allRows = rows;
        this.rows = rows;
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });

    db.collection("user")
      .where("status", "==", "approved")
      .where("vip", "==", true)
      .get()
      .then(querySnapshot => {
        const rows = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          data.id = doc.id;
          rows.push(data);
        });
        this.vips = rows;
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  watch: {
    onlyVip: function(newOnlyVip) {
      if (newOnlyVip) {
        const vipEmails = this.vips.map(vip => vip.email);
        this.rows = this.allRows.filter(row => vipEmails.includes(row.email));
      } else this.rows = this.allRows;
    }
  },
  methods: {
    truncate: (string, n) => {
      return string.length > n ? string.substr(0, n - 1) + "..." : string;
    },
    copyToClipboard: function(text) {
      const el = document.createElement("textarea");
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    copyToPostbot: function(deal) {
      deal.originalPrice = deal.originalPrice.replace(".", ",");
      deal.newPrice = deal.newPrice.replace(".", ",");
      this.copyToClipboard(JSON.stringify({ deal }));
      this.setStatus(deal, "published");
    },
    rejectDeal: function(deal, reason) {
      const reasonOption = options.find(opt => opt.id === reason);
      this.setStatus(deal, "rejected", reasonOption.value);
    },
    setStatus: function(deal, status, notes) {
      const db = firebase.firestore();
      var dealRef = db.collection("deals").doc(deal.id);
      console.log(deal.id);
      if (status === "published")
        notes = `Published on ${new Date().toLocaleDateString("en-US")}`;
      return dealRef
        .update({
          status,
          notes
        })
        .then(() => {
          console.log(`Document ${deal.id} successfully updated!`);
          this.rows = this.rows.filter(row => row.id !== deal.id);
        })
        .catch(function(error) {
          console.error(`Error updating document ${deal.id}: ${error}`);
        });
    }
  }
};
</script>
